/* eslint-disable react-hooks/exhaustive-deps */

import {
    Button,
    CircularProgress,
    createStyles,
    Grid,
    makeStyles,
    Theme,
    Typography,
} from "@material-ui/core";

import React, { useContext } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import announcePic from "../../../images/announcePic.png";
import { colors } from "../../../styles/defaultColors";
import { CountryService } from "../Countries/services/EquipmentCountry";
import { PropertyService } from "../../Properties/services/PropertyService";
import { HotelService } from "./services/hotelService";
import SessionHandler from "../../../https/SessionHandler";
import { UserContext } from "../../../contexts/AppContext";
import { useHistory } from "react-router-dom";
import {
    IAddress,
    ILocation,
    IPropertyType,
} from "../../../utils/AnnounceInterfaces";
import { Error } from "@material-ui/icons";
import {
    addressDefaultValue,
    HotelInputDefaultValue,
    locationDefaultValue,
    propertyTypesDefaultValue,
} from "../../../utils/defaultNullValues";
import { IHotel } from "../../../utils/HotelInterface";
import { useTranslation } from "react-i18next";
import { fileToBase64 } from "../../../utils/App";
import { StepThree } from "../../Properties/components/FormSteps/StepThree";
import {
    EAddressErrorMessages,
    EAnnounceErrorMessages,
    EPropertyErrorMessages,
    HotelErrorMessages,
} from "../../../utils/enum/properties";
import { ProfilHôtel } from "./ProfilHotel";
import { MutiplePhoto } from "./PhotoMultiple";
import { LocalisationHotel } from "./Localisation";
import Spin from "../../../images/Spin";
import { IPays } from "../../../utils/DiversInterfaces";
import { IVille } from "../../../utils/DiversInterfaces";
import { villeDefaultValue } from "../../../utils/defaultNullValues";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        properties: {
            width: "100%",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: {
                minHeight: 1200,
            },
            marginBottom: 120,
        },
        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
        },
        propertiesStepper: {
            width: "40%",
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                width: "70%",
            },
            "&.MuiPaper-root": {
                background: "none",
            },
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        showErrors: {},
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50,
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
            textTransform: "capitalize",
        },
        ButtonPrevious: {
            textTransform: "capitalize",
            color: "#000000",
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        "@global": {
            ".MuiStepIcon-root.MuiStepIcon-active, .MuiStepIcon-root.MuiStepIcon-completed":
                {
                    color: "#890608",
                },
            ".MuiOutlinedInput-input": {
                padding: "9px 14px",
            },
        },
    })
);

function getSteps() {
    return ["Création hôtel", "Create an ad", "Set geolocation", "Add photos"];
}

const countryService = new CountryService();
const propertyService = new PropertyService();
const hotelService = new HotelService();

export function CreationHotel() {
    const classes = styles();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const history = useHistory();
    const [activeStep, setActiveStep] = React.useState<number>(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const steps = getSteps();
    const [address, setAddress] = React.useState<IAddress>(addressDefaultValue);
    const [, setPropertyTypeList] = React.useState<IPropertyType[]>(
        propertyTypesDefaultValue
    );

    const [loading, setLoading] = React.useState(true);
    let errors: string[] = [];
    const [isSaving, setIsSaving] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [location, setLocation] =
        React.useState<ILocation>(locationDefaultValue);
    const { t } = useTranslation<'common'>();
    const [paysList, setPaysList] = React.useState<IPays[]>([]);
    const [paysSelected, setPaysSelected] = React.useState<IPays | null>(null);
    const [villeSelected, setVilleSelected] = React.useState<IVille | null>(null);
    const [tab, setTab] = React.useState<IVille[]>([]);

    /*information hotel*/
    const [hotelInput, setHotel] = React.useState<IHotel>(
        HotelInputDefaultValue
    );
    const [note, setNote] = React.useState<number | null>(0);
    const [fileURL, setFileURL] = React.useState<string>("");
    const [logourgent, setLogoPaysurgent] = React.useState<string>("");
    const [paysgerant, setPayGerant] = React.useState<string>("");
    const [codephoneurgent, setCodePhoneurgent] = React.useState<string>("");
    const [logourgentProp, setLogoPaysurgentProp] = React.useState<string>("");
    const [paysProp, setPayProp] = React.useState<string>("");
    const [typeSelected,setTypeSelected]=React.useState([])
    const [, setChoixLogement] = React.useState<string>("");
    const [codephoneurgentProp, setCodePhoneurgentProp] =
        React.useState<string>("");
    const handleOnChangeNationUrgent = (val: any) => {
        setCodePhoneurgent(val.dial_code);
        setPayGerant(val.name);
        setLogoPaysurgent(val.code);
    };
    const handleOnChangeNationUrgentProp = (val: any) => {
        setCodePhoneurgentProp(val.dial_code);
        setPayProp(val.name);
        setLogoPaysurgentProp(val.code);
    };
    const handleOnChangeSelect = (key: string, v: string) => {
        setHotel({ ...hotelInput, [key]: v });
    };
    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            phoneUrgent: hotelInput.numberPhoneUrgent,
            codephoneurgent: codephoneurgent,
            paysgerant: paysgerant,
        });
    }, [
        hotelInput.numberPhoneUrgent,
        hotelInput.paysgerant,
        hotelInput.codephoneurgent,
    ]);
    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            phoneUrgentProp: hotelInput.phone,
            codephoneurgentProp: codephoneurgentProp,
            paysProp: paysProp,
        });
    }, [hotelInput.phone, hotelInput.paysProp, hotelInput.phoneUrgentProp]);
    

    React.useEffect(() => {
        countryService.getAllCountries()
          .then(response => {
            if (response.success) {
              setPaysList(response.data);
              //console.log('Fetched countries with embedded cities:', response.data);
            }
          });
      }, []);


    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    history.push("/");
                });
        } else {
            setLoading(true);
            propertyService
                .getAllPropertyTypes()
                .then((response) => {
                    if (response.success) {
                        setPropertyTypeList(response.data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                });
        }
    }, [user, history, isConnected, setUser]);

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };

    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            location,
        });
    }, [location]);

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        let showNextStep = true;
        if (activeStep === 0) {
            showNextStep = isHotelValidate(hotelInput);
        } else if (activeStep === 1) {
            showNextStep = isAdressValidate(address);
        } else if (activeStep === 3) {
            showNextStep = isPhotosValidate(hotelInput);
        }

        if (showNextStep) {
            errors = [];
            setErrorMessages("");
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        } else {
            showErrorsMessages();
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    

    const onChangeAddress = (event: any): void => {
        const { name, value } = event.target;    
            // Update address and property for other fields
            setAddress((prevAddress) => ({
                ...prevAddress,
                [name]: value,
            }));
    };

    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            address,
        });
    }, [address]);

    React.useEffect(() => {
        hotelService
            .getHotelByUser(user._id)
            .then((response) => {
                if (response.success) {
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [setLoading]);


    const onChangeLocation = (longitude: number, latitude: number): void => {
        setLocation({ longitude, latitude });
    };

    const onChangePays = (value: IPays) => {
        setPaysSelected(value);
            setAddress((prevAddress) => ({
                ...prevAddress,
                country: value,
                city: invalidCity
            }));
    };



    // Update the villes list generation
    React.useEffect(() => {
        if (address.country?._id) {
          const selectedCountry = paysList.find(p => p._id === address.country?._id);
          setTab(selectedCountry?.villes || []);
          //console.log('Derived cities:', selectedCountry?.villes);
        }
      }, [address.country, paysList]);



    const invalidCity: IVille = {
            _id: '', // Default empty ID
            count: '0', // Placeholder count
            name: 'Invalid City', // Default name
            nomFR: 'Ville invalide', // Optional
            nomEN: 'Invalid City', // Optional
            quartiers: [], // Optional
        };    


    const onChangeVille = (value: IVille) => {
        //console.log("Selected city:", value); // Log the selected city
            setVilleSelected(value); // Keep track of selected city
            setAddress((prevAddress) => ({
                ...prevAddress,
                city: value, // Save the full object, not just the name
            }));       
    };

   


    /* Add this useEffect to track tab changes
    React.useEffect(() => {
        console.log('[CreationHotel] Available cities list updated:', tab);
    }, [tab]);

    // Add this useEffect to track address changes
    React.useEffect(() => {
        console.log('[CreationHotel] Current address state:', address);
    }, [address]); */

   

    /**information pour les hotels**/
    const handlChangeAvatar = async (event: any) => {
        const file = event.target.files[0];
        setFileURL(URL.createObjectURL(file));
        setHotel({ ...hotelInput, companyLogo: await fileToBase64(file) });
    };

    const onChangeStar = (
        event: React.SyntheticEvent<Element, Event>,
        newValue: number | null
    ) => {
        const stars = newValue === null ? 0 : newValue;
        setNote(stars);
        setHotel({ ...hotelInput, stars });
    };

    const handleChange = (n: string, v: string) => {
        setHotel({ ...hotelInput, [n]: v });
    };
    const onChangePhotoHotel = (photos: any) => {
        setHotel({
            ...hotelInput,
            photos,
        });
    };
    const handleChangePropertyType=(value: any)=>{
        setTypeSelected(value)
        if(value!=null){
            setChoixLogement(value.name)
            setHotel({
                ...hotelInput,
                typeLogement:value.name,
            });
        }
    }
    //console.log("value value",hotelInput)

    const actualStepForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <ProfilHôtel
                        fileURL={fileURL}
                        hotelInput={hotelInput}
                        note={note}
                        handlChangeAvatar={handlChangeAvatar}
                        logourgent={logourgent}
                        handleOnChangeNationUrgent={handleOnChangeNationUrgent}
                        handleOnChangeSelect={handleOnChangeSelect}
                        codephoneurgent={codephoneurgent}
                        propertyTypeList={[{id:1,name:"Hôtel", label:"label.hotel"},{id:2,name:"Appartement", label:"label.immeuble-d-appartement"}]}
                        typeSelected={typeSelected}
                        handleChangePropertyType={handleChangePropertyType}
                        onChangeStar={onChangeStar}
                        handleChange={handleChange}
                        handleOnChangeNationUrgentProp={
                            handleOnChangeNationUrgentProp
                        }
                        logourgentProp={logourgentProp}
                        codephoneurgentProp={codephoneurgentProp}
                    />
                );
            case 1:
                return (
                    <LocalisationHotel
                        handleChange={onChangeAddress}
                        values={address}
                        onChangeMultiSelect={onChangePays}
                        paysSelected={paysSelected}
                        paysList={paysList}
                        country={address.country}
                        onChangeVille={onChangeVille}
                        villeSelected={villeSelected}
                        tab={tab}
                    />
                );
            case 2:
                return (
                    <StepThree
                        handleChange={onChangeLocation}
                        values={location}
                        handleNext={handleNext}
                        autoGeolocate={true}
                    />
                );
            case 3:
                return <MutiplePhoto handleChangePhotos={onChangePhotoHotel} />;
            default:
            // do nothing
        }
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY NAME COMPANY") {
                allErrorMessages +=
                    "," + t(`label.error.${HotelErrorMessages.Emptyname}`);
            } else if (error === "EMPTY OWNER NAME") {
                allErrorMessages +=
                    "," + t(`label.error.${HotelErrorMessages.EmptyOwnerName}`);
            } else if (error === "EMPTY ROOM") {
                allErrorMessages +=
                    "," + t(`label.error.${EPropertyErrorMessages.EmptyRoom}`);
            } else if (error === "EMPTY CITY") {
                allErrorMessages +=
                    "," + t(`label.error.${EAddressErrorMessages.EmptyCity}`);
            } else if (error === "EMPTY COUNTRY") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAddressErrorMessages.EmptyCountry}`);
            } else if (error === "EMPTY STATE") {
                allErrorMessages +=
                    "," + t(`label.error.${EAddressErrorMessages.EmptyState}`);
            } else if (error === "EMPTY ZIPCODE") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAddressErrorMessages.EmptyZipcode}`);
            } else if (error === "EMPTY DESCRIPTION") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.EmptyDescription}`);
            } else if (error === "EMPTY QUARTIER") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.EmptyQuartier}`);
            } else if (error === "INSUFFICIENT PICTURES") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EPropertyErrorMessages.InsufficientPictures}`
                    );
            }
        });
        setErrorMessages(
            allErrorMessages.substring(1, allErrorMessages.length)
        );
    };

    const isHotelValidate = (values: IHotel): boolean => {
        if (values.companyName === "") {
            if (!errors.includes("EMPTY NAME COMPANY"))
                errors = [...errors, "EMPTY NAME COMPANY"];
        } else if (values.proprietaire === "") {
            if (!errors.includes("EMPTY OWNER NAME"))
                errors = [...errors, "EMPTY OWNER NAME"];
        } else if (values.rooms === 0) {
            if (!errors.includes("EMPTY ROOM"))
                errors = [...errors, "EMPTY ROOM"];
        }

        return !Boolean(errors.length);
    };

    // Update the address validation
    const isAdressValidate = (values: IAddress): boolean => {
        let valid = true;
        if (!values.country?._id) {
            errors = [...errors, "EMPTY COUNTRY"];
            valid = false;
        }
        if (!values.city?._id) {
            errors = [...errors, "EMPTY CITY"];
            valid = false;
        }
        if (!values.quartier) {
            errors = [...errors, "EMPTY QUARTIER"];
            valid = false;
        }
        return valid;
    };

    const isPhotosValidate = (values: IHotel): boolean => {
        if (values.photos.length < 5) {
            if (!errors.includes("INSUFFICIENT PICTURES"))
                errors = [...errors, "INSUFFICIENT PICTURES"];
        }
        return !Boolean(errors.length);
    };
    const handleSubmit = () => {
        if (isPhotosValidate(hotelInput)) {
            setIsSaving(true);
            hotelService
                .saveHotel({ ...hotelInput, admin: user._id, photos: [] })
                .then((response) => {
                    if (response.success) {
                        if (hotelInput.photos.length) {
                            hotelInput.photos.forEach(
                                (photo: any, index: number) => {
                                    let formD = new FormData();
                                    formD.append(`photos`, photo);
                                    hotelService
                                        .savePropertyPhotosById(
                                            response.data._id,
                                            formD
                                        )
                                        .then((response) => {
                                            setHotel({
                                                ...hotelInput,
                                                companyName: "",
                                            });
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            );
                        }
                        setIsSaving(false);
                        history.push("/hotel");
                    }
                    setIsSaving(false);
                    // setIsUpdating(false);
                })
                .catch((error) => {
                    setIsSaving(false);
                    console.log(error);
                });
        } else {
            showErrorsMessages();
        }
    };

    const handleCancel = () => {
        history.push("/announces");
    };

    return (
        <div className={classes.properties}>
            <Grid container direction="column">
                <Grid item className={classes.propertiesHeader}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {activeStep === 6
                            ? t("annonce.title.creezVotreAnnonce")
                            : t("annonce.title.decrivezVotreHotel")}
                    </Typography>
                    <Stepper
                        activeStep={activeStep}
                        className={classes.propertiesStepper}
                    >
                        {steps.map((label, index) => {
                            const stepProps: { completed?: boolean } = {};
                            const labelProps: { optional?: React.ReactNode } =
                                {};
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>
                                        {/* {label} */}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Grid>
                <Grid>
                    {/* <MessageBrouillon /> */}
                </Grid>
                <Grid
                    item
                    container
                    spacing={3}
                    justifyContent="center"
                    direction="row"
                >
                    <Grid item lg={6} md={6} sm={12}>
                        <img src={announcePic} alt="Announce illustration" />
                    </Grid>

                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className={classes.propertiesCheck}
                    >
                        {loading ? (
                            <CircularProgress
                                size={32}
                                style={{ color: "#890608" }}
                            />
                        ) : (
                            <>
                                <div className={classes.propertiesCheckbox}>
                                    {actualStepForm()}
                                    <div className={classes.showErrors}>
                                        {errorMessages && (
                                            <div className={classes.errors}>
                                                <Typography>
                                                    <Error />
                                                    <br />
                                                    <span>{errorMessages}</span>
                                                </Typography>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {activeStep < steps.length && (
                                    <div className={classes.propertiesBtn}>
                                        <Button
                                            // disabled={activeStep === 0}
                                            onClick={
                                                activeStep === 0
                                                    ? handleCancel
                                                    : handleBack
                                            }
                                            className={classes.ButtonPrevious}
                                        >
                                            {activeStep === 0
                                                ? t("propriete.buttonCancel")
                                                : t("propriete.buttonPrevious")}
                                        </Button>
                                        <Button
                                            disabled={
                                                activeStep ===
                                                    steps.length - 1 && isSaving
                                            }
                                            onClick={
                                                activeStep === steps.length - 1
                                                    ? handleSubmit
                                                    : handleNext
                                            }
                                            endIcon={
                                                activeStep ===
                                                    steps.length - 1 &&
                                                isSaving ? (
                                                    <Spin />
                                                ) : null
                                            }
                                            className={classes.Button}
                                        >
                                            {activeStep === steps.length - 1
                                                ? `${t(
                                                      "propriete.buttonValidate"
                                                  )}`
                                                : `${t(
                                                      "propriete.buttonNext"
                                                  )}`}
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}
